import { initialErrors } from '../Constants/Subdistricts.constants';
import { Types } from '../Constants/Types';
import SubdistrictType from '../Interfaces/subdistricts.interface';

const SubdistrictsReducer = (
  state: SubdistrictType['status'] = {
    subdistricts: [],
    lsubdistricts: false,
    error: initialErrors,
    pages: 0,
    total: 0,
  },
  action: SubdistrictType['action'],
) => {
  switch (action.type) {
    case Types.FETCH_SUBDISTRICTS:
      return {
        ...state,
        subdistricts: action.payload,
        pages: action.pages,
        total: action.total,
      };

    case Types.START_SUBDISTRICTS:
      return { ...state, lsubdistricts: true };

    case Types.END_SUBDISTRICTS:
      return { ...state, lsubdistricts: false };

    case Types.ERROR_SUBDISTRICT:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };

    case Types.RESET_SUBDISTRICT:
      return { ...state, error: initialErrors };

    default:
      return state;
  }
};

export default SubdistrictsReducer;
